// export const BASE_URL="http://localhost:6010"  //url of backend
export const BASE_URL="https://ems-backend-99ic.onrender.com" 